import React from 'react';
import styled from 'styled-components';
import { FiUpload, FiDatabase, FiSettings } from 'react-icons/fi';

const MenuContainer = styled.nav`
  background: #ffffff;
  border-radius: 12px;
  padding: 15px;
  margin-bottom: 20px;
  display: flex;
  gap: 12px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
  flex-wrap: wrap;
`;

const MenuButton = styled.button`
  background: ${props => props.$active ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' : '#f5f5f5'};
  color: ${props => props.$active ? '#ffffff' : '#616161'};
  border: none;
  padding: 10px 20px;
  font-size: 0.9rem;
  font-weight: 600;
  font-family: 'Segoe UI', sans-serif;
  cursor: pointer;
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s ease;
  
  &:hover {
    background: ${props => props.$active ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' : '#eeeeee'};
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.2);
  }
  
  svg {
    font-size: 1.1rem;
  }
`;

const MenuBar = ({ activeView, setActiveView }) => {
  return (
    <MenuContainer>
      <MenuButton 
        $active={activeView === 'upload'}
        onClick={() => setActiveView('upload')}
      >
        <FiUpload /> Extract
      </MenuButton>
      
      <MenuButton 
        $active={activeView === 'connectors'}
        onClick={() => setActiveView('connectors')}
      >
        <FiDatabase /> Connectors
      </MenuButton>
      
      <MenuButton 
        $active={activeView === 'settings'}
        onClick={() => setActiveView('settings')}
      >
        <FiSettings /> Settings
      </MenuButton>
    </MenuContainer>
  );
};

export default MenuBar;